module.exports = __webpack_public_path__ + "assets/20d74484bf26701a055a84c8fe83b5d1.png";